import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Cached(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M8.913 2.513C13.146.88 19.28 3.118 20.958 8.72a1 1 0 11-1.916.574c-1.322-4.412-6.189-6.158-9.41-4.915a5.176 5.176 0 00-1.868 1.266l-.001.001a1 1 0 01-.055.06L5.418 8H9a1 1 0 010 2H3.12A.998.998 0 012 9.004V4a1 1 0 012 0v2.59l2.268-2.272a3.44 3.44 0 01.174-.185 7.175 7.175 0 012.47-1.62zm-6.87 12.765c1.678 5.603 7.81 7.842 12.045 6.207a7.178 7.178 0 002.615-1.771l.013-.015.016-.018L20 16.407v2.59a1 1 0 102 0v-5a1 1 0 00-1-1h-6a1 1 0 100 2h3.582l-3.29 3.295-.055.06v.001c-.003.003-.008.01-.017.018a4.806 4.806 0 01-.453.423c-.33.272-.807.597-1.4.825-3.22 1.244-8.087-.503-9.409-4.915a1 1 0 10-1.916.574z",
    clipRule: "evenodd"
  }));
}

export default Cached;